import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './CashierSubscriptionReminderModal.css';

export function CashierSubscriptionReminderModal({ isOpen }: { isOpen: boolean }) {
  const { t } = useLanguage();
  if (!isOpen) return null;
  return (
    <div className="cashier-sub-reminder-overlay" role="presentation">
      <div className="cashier-sub-reminder-dialog" role="alertdialog" aria-modal="true" aria-labelledby="cashier-sub-reminder-title">
        <h2 id="cashier-sub-reminder-title" className="cashier-sub-reminder-title">
          {t('cashierSubscriptionReminder_title')}
        </h2>
        <p className="cashier-sub-reminder-body">{t('cashierSubscriptionReminder_body')}</p>
      </div>
    </div>
  );
}
